//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
  props: {
    period: String,
    periodType: String,
    ready: String,
    loc: Array,
    cutstatus: String,
    txtso: String,
    loadstatus: String,
    // ReadinessGroup: Object,
    api: String,
    customer: String,
    brand: String,
    red01: String,
    red02: String,
    red03: String,
    red04: String,
    red05: String,
    red06: String,
    red07: String,
    tab: String
  },
  data () {
    return {
      indeterminateotif: true,
      showvalueotif: false,
      indeterminatecum: true,
      showvaluecum: false,
      bar2: false,
      reloaddata: false,
      rCircle: 19,
      newcumulative: 0,
      newcumulativecolor: 'red',
      otif_sub: {
        wk: '',
        so_color: '',
        so_percent: 0,
        so_otif: 0,
        so_total: 0,
        so_label: '',
        pcs_color: '',
        pcs_percent: 0,
        pcs_label: ''
      },
      objWeek: {
        total: 0,
        fg: 0,
        ship: 0,
        pending: 0,
        complete: 0,
        otif: 0,
        otif_sub: 0,
        total_sub: 0,
        color_complete: 'red',
        color_otif: 'red'
      },
      data_summary: {
        TOTAL_PCS: 0,
        TOTAL_CUT: 0,
        READY: 0,
        PENDING: 0,
        TOTALROW: 0
      },
      wk_summary: {
        pcs_color: '',
        pcs_cum: 0,
        pcs_pending: 0,
        pcs_percent: 0,
        pcs_total: 0,
        pcs_cut: 0,
        so_color: '',
        so_cum: 0,
        so_percent: 0,
        so_total: 0,
        wk: ''
      },
      sodoc: [],
      so: {},
      listSO: [],
      polist1: [],
      polist2: [],
      polist3: [],
      windowHeight: 0,
      txt: '',
      comp1: 0,
      comp2: 0
    }
  },
  created () {
    // console.log(this.period);
    // this.CheckLocal()
    this.LoadFirst()
  },
  watch: {
    red01: function (newVal, oldVal) {
      this.loadpie()
    },
    red02: function (newVal, oldVal) {
      this.loadpie()
    },
    red03: function (newVal, oldVal) {
      this.loadpie()
    },
    red04: function (newVal, oldVal) {
      this.loadpie()
    },
    red05: function (newVal, oldVal) {
      this.loadpie()
    },
    red06: function (newVal, oldVal) {
      this.loadpie()
    },
    red07: function (newVal, oldVal) {
      this.loadpie()
    }
    // customer: function(newVal, oldVal) {
    //   this.loadpie()
    // },
    // brand: function(newVal, oldVal) {
    //   this.loadpie()
    // }
  },
  async mounted () {},

  methods: {
    async loadpie () {
      // let a = await this.loadpieotif()
      await this.loadpieotifnew()
      await this.loadpiecum()
    },
    LoadFirst () {
      this.pulling = setTimeout(() => {
        // this.loadsum()
        this.loadpie()
        // this.LoadPeriod()
        this.Loadwkdatasum()
        this.Loadwkdata()
      }, 200)
    },
    isEmpty (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false
      }
      return true
    },

    chkReadiness (val) {
      if (val === '[Y]') {
        return 'Y'
      }

      return '_'
    },

    // async loadpieotif() {
    //   this.showvalueotif = false
    //   this.indeterminateotif = true
    //   const postjson = {
    //     authen: { keycode: this.$keycode },
    //     filter: {
    //       periodtype: this.periodType,
    //       wk: this.period,
    //       loc: this.loc,
    //       customer: this.customer,
    //       brand: this.brand,
    //       r1: this.chkReadiness(this.red01),
    //       r2: this.chkReadiness(this.red02),
    //       r3: this.chkReadiness(this.red03),
    //       r4: this.chkReadiness(this.red04),
    //       r5: this.chkReadiness(this.red05),
    //       r6: this.chkReadiness(this.red06),
    //       r7: this.chkReadiness(this.red07)
    //     }
    //   }
    //   await axios({
    //     method: "post",
    //     url: `${this.$apiflask}nygctroom/board1/otif`, // php
    //     data: postjson
    //   }).then(res => {
    //     // console.log(res.data)
    //     this.otif_sub = res.data
    //     this.showvalueotif = true
    //     this.indeterminateotif = false
    //   })
    // },

    // async loadpieotifnew () {
    //   this.showvalueotif = false
    //   this.indeterminateotif = true
    //   const postjson = {
    //     filter: {
    //       periodtype: this.periodType,
    //       ps: this.period,
    //       pe: this.period,
    //       loc: this.loc,
    //       customer: this.customer,
    //       brand: this.brand,
    //       r1: this.chkReadiness(this.red01),
    //       r2: this.chkReadiness(this.red02),
    //       r3: this.chkReadiness(this.red03),
    //       r4: this.chkReadiness(this.red04),
    //       r5: this.chkReadiness(this.red05),
    //       r6: this.chkReadiness(this.red06),
    //       r7: this.chkReadiness(this.red07)
    //     }
    //   }

    //   await axios({
    //     method: 'post',
    //     url: `${this.$apiflask}nygctroom/board1/perform/chartdata`, // php
    //     data: postjson
    //   }).then(res => {
    //     this.otif_sub = res.data.pie
    //     this.showvalueotif = true
    //     this.indeterminateotif = false
    //   })
    // },

    async loadpieotifnew () {
      try {
        this.showvalueotif = false
        this.indeterminateotif = true
        let params = new FormData()
        params.append('periodtype', this.periodType)
        params.append('ps', this.period)
        params.append('pe', this.period)
        params.append('loc', JSON.stringify(this.loc))
        params.append('customer', this.customer)
        params.append('brand', this.brand)
        params.append('r1', this.chkReadiness(this.red01))
        params.append('r2', this.chkReadiness(this.red02))
        params.append('r3', this.chkReadiness(this.red03))
        params.append('r4', this.chkReadiness(this.red04))
        params.append('r5', this.chkReadiness(this.red05))
        params.append('r6', this.chkReadiness(this.red06))
        params.append('r7', this.chkReadiness(this.red07))
        await axios({
          method: 'post',
          // url: 'http://localhost/nygcontrolroom/api/Page01.php/chartdata',
          url: this.$api + 'Page01.php/chartdata',
          data: params
        }).then(res => {
          if (res.data.status) {
            this.otif_sub = res.data.data
            this.showvalueotif = true
            this.indeterminateotif = false
          } else {
            this.otif_sub = res.data.data
            this.showvalueotif = true
            this.indeterminateotif = false
          }
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.showvalueotif = false
        this.indeterminateotif = true
      }
    },

    // async loadpiecum () {
    //   this.showvaluecum = false
    //   this.indeterminatecum = true
    //   const postjson = {
    //     authen: { keycode: this.$keycode },
    //     filter: {
    //       periodtype: this.periodType,
    //       wk: this.period,
    //       loc: this.loc,
    //       customer: this.customer,
    //       brand: this.brand,
    //       r1: this.chkReadiness(this.red01),
    //       r2: this.chkReadiness(this.red02),
    //       r3: this.chkReadiness(this.red03),
    //       r4: this.chkReadiness(this.red04),
    //       r5: this.chkReadiness(this.red05),
    //       r6: this.chkReadiness(this.red06),
    //       r7: this.chkReadiness(this.red07)
    //     }
    //   }
    //   await axios({
    //     method: 'post',
    //     // url: `${this.$apiflask}/nygctroom/board1/cumulative`, // php
    //     data: postjson
    //   }).then(res => {
    //     console.log('wk_summary')
    //     console.log(res.data)
    //     this.wk_summary = res.data
    //     this.showvaluecum = true
    //     this.indeterminatecum = false
    //     console.log('cum')
    //   })
    // },

    async loadpiecum () {
      try {
        this.showvaluecum = false
        this.indeterminatecum = true
        let params = new FormData()
        params.append('keycode', this.$keycode)
        params.append('periodtype', this.periodType)
        params.append('wk', this.period)
        params.append('loc', JSON.stringify(this.loc))
        params.append('customer', this.customer)
        params.append('brand', this.brand)
        params.append('r1', this.chkReadiness(this.red01))
        params.append('r2', this.chkReadiness(this.red02))
        params.append('r3', this.chkReadiness(this.red03))
        params.append('r4', this.chkReadiness(this.red04))
        params.append('r5', this.chkReadiness(this.red05))
        params.append('r6', this.chkReadiness(this.red06))
        params.append('r7', this.chkReadiness(this.red07))
        await axios({
          method: 'post',
          // url: 'http://localhost/nygcontrolroom/api/Page01.php/cumulative',
          url: this.$api + 'Page01.php/cumulative',
          data: params
        }).then(res => {
          if (res.data.status) {
            this.wk_summary = res.data.data
            this.showvaluecum = true
            this.indeterminatecum = false
          } else {
            this.wk_summary = res.data.data
            this.showvaluecum = false
            this.indeterminatecum = true
          }
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.showvaluecum = false
        this.indeterminatecum = true
      }
    },

    // loadsum() {
    //   let params = new FormData()
    //   params.append("wk", this.period)
    //   params.append("loc", this.loc)
    //   let url = ""
    //   if (this.periodType == "MRD_W") {
    //     url = "PeriodDataMRD"
    //   } else if (this.periodType == "RDD_W") {
    //     url = "PeriodDataRDD"
    //   } else if (this.periodType == "RDD_W_4") {
    //     url = "PeriodDataRDD4"
    //   } else if (this.periodType == "RDD_W_5") {
    //     url = "PeriodDataRDD5"
    //   } else if (this.periodType == "TARGET_BY_RDD") {
    //     url = "PeriodDataOTP"
    //   }
    //   axios({
    //     method: "post",
    //     url: `${this.$apiFix}Page01_sum.php/${url}`,
    //     data: params,
    //   }).then((res) => {
    //     console.log(res.data)
    //     this.readypcs = res.data.ready
    //     this.pendingpcs = res.data.pending
    //     this.totalpcs = res.data.total_pcs
    //     this.cutpcs = res.data.total_cut
    //   })
    // },

    async Loadwkdata () {
      try {
        // console.log(this.loc)
        const postjson = {
          authen: { keycode: this.$keycode },
          filter: {
            wk: this.period,
            so: this.txtso,
            loc: this.loc,
            customer: this.customer,
            brand: this.brand,
            cutstatus: this.cutstatus,
            ready: this.ready,
            periodtype: this.periodType
          }
        }
        await axios({
          method: 'post',
          url: `${this.$apiflask}/nygctroom/board1/wkdata`, // php
          data: postjson
        }).then(res => {
          this.sodoc = res.data.rows
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
      }
    },

    // async Loadwkdata () {
    //   try {
    //     let params = new FormData()
    //     params.append('periodtype', this.periodType)
    //     params.append('wk', this.period)
    //     params.append('so', this.txtso)
    //     params.append('loc', JSON.stringify(this.loc))
    //     params.append('customer', this.customer)
    //     params.append('brand', this.brand)
    //     params.append('cutstatus', this.cutstatus)
    //     params.append('ready', this.ready)
    //     await axios({
    //       method: 'post',
    //       // url: 'http://localhost/nygcontrolroom/api/Page01.php/wkdata',
    //       url: this.$api + 'Page01.php/wkdata',
    //       data: params
    //     }).then(res => {
    //       if (res.data.status) {
    //         this.sodoc = res.data.data
    //       } else {
    //         this.sodoc = res.data.data
    //       }
    //     })
    //   } catch (err) {
    //     this.$q.notify({
    //       position: 'top-right',
    //       timeout: 2500,
    //       textColor: 'white',
    //       color: 'red',
    //       message: err,
    //       html: true
    //     })
    //   }
    // },

    async Loadwkdatasum () {
      const postjson = {
        authen: { keycode: this.$keycode },
        filter: {
          wk: this.period,
          loc: this.loc,
          periodtype: this.periodType
          // so: this.txtso,
          // customer: this.customer,
          // brand: this.brand,
          // cutstatus: this.cutstatus,
          // ready: this.ready,
          // periodType: this.periodType,
        }
      }
      // console.log(this.loc)
      await axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board1/wkdatasum`, // php
        data: postjson
      }).then(res => {
        // console.log(res.data)
        this.data_summary = res.data.data_summary[0]

        // this.newcumulative =
        //   (parseInt(this.data_summary.READY) * 100) /
        //   parseInt(this.data_summary.TOTAL_PCS)

        // if (this.newcumulative >= 97) {
        //   this.newcumulativecolor = "green"
        // } else if (this.newcumulative < 85) {
        //   this.newcumulativecolor = "red"
        // } else {
        //   this.newcumulativecolor = "yellow"
        // }
      })
    },

    displayLoaded (obj) {
      if (this.loadstatus === 'L') {
        if (obj.LOADED_QTY > 0) {
          return true
        } else {
          return false
        }
      } else if (this.loadstatus === 'P') {
        if (obj.PENDING_QTY > 0) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },

    openDialog (obj) {
      // console.log(obj)
      this.bar2 = true
      this.so = obj

      let params = new FormData()

      // params.append("periodType", this.periodType)
      params.append('bu', obj.BU)
      // params.append("Ready", obj.SO_READY)
      params.append('so', obj.SO_NO_DOC)

      axios({
        method: 'post',
        // url: this.$apiflask + 'WIPStep01',
        url: this.$apiFix + 'Page01.php/soDetail',
        data: params
      }).then(res => {
        this.listSO = res.data
      })

      this.LoadPOList1(obj.SO_NO_DOC, obj.BU, 'FABRIC')
      this.LoadPOList2(obj.SO_NO_DOC, obj.BU, 'SEW')
      this.LoadPOList3(obj.SO_NO_DOC, obj.BU, 'PACK')
    },
    // eslint-disable-next-line camelcase
    LoadPOList1 (so_no_doc, bu, rm_type) {
      // console.log(bu)
      let params = new FormData()
      params.append('so_no_doc', so_no_doc)
      params.append('rm_type', rm_type)
      params.append('bu', bu)
      axios({
        method: 'post',
        url: this.$apiFix + 'readinessWIP.php/getPOList',
        data: params
      }).then(res => {
        this.polist1 = res.data
      })
    },
    // eslint-disable-next-line camelcase
    LoadPOList2 (so_no_doc, bu, rm_type) {
      let params = new FormData()
      params.append('so_no_doc', so_no_doc)
      params.append('rm_type', rm_type)
      params.append('bu', bu)
      axios({
        method: 'post',
        url: this.$apiFix + 'readinessWIP.php/getPOList',
        data: params
      }).then(res => {
        // console.log(res.data)
        this.polist2 = res.data
      })
    },
    // eslint-disable-next-line camelcase
    LoadPOList3 (so_no_doc, bu, rm_type) {
      let params = new FormData()
      params.append('so_no_doc', so_no_doc)
      params.append('rm_type', rm_type)
      params.append('bu', bu)
      axios({
        method: 'post',
        url: this.$apiFix + 'readinessWIP.php/getPOList',
        data: params
      }).then(res => {
        // console.log(res.data)
        this.polist3 = res.data
      })
    },

    getClass (obj) {
      let chk =
        this.red01 +
        this.red02 +
        this.red03 +
        this.red04 +
        this.red05 +
        this.red06 +
        this.red07

      // if (obj.SO_READY == 'Y') {
      //   return 'bg-green-2'
      // } else {
      //   return 'bg-red-2'
      // }
      // console.log(chk)
      // console.log(obj.SO_READY_NEW)
      let chkReg = '^(' + chk + ')$'

      var re = new RegExp(chkReg, 'g')

      var OK = re.exec(obj.SO_READY_NEW)
      if (OK) {
        return 'bg-green-2'
      } else {
        return 'bg-red-2'
      }
    }
  }
}
